import { CriticalIcon, EmptyState } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

export const TagsErrorState = (): JSX.Element => (
  <EmptyState variant="critical">
    <EmptyState.Icon>
      <CriticalIcon />
    </EmptyState.Icon>
    <EmptyState.Heading>Failed to load tags</EmptyState.Heading>
    <EmptyState.Description>
      Something went wrong. Please try again later.
    </EmptyState.Description>
  </EmptyState>
)
